import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartFrame from "./ChartFrame";
import { Box } from "@chakra-ui/react";

const CenteredLegend = ({ label }) => (
  <Box
    style={{
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      width: "100%",
    }}
  >
    <Box
      as="span"
      style={{
        alignItems: "center",
        color: "var(--blue)",
        display: "inline-flex",
        fontSize: 14,
        gap: 4,
        justifyContent: "center",
      }}
    >
      <Box
        as="span"
        aria-hidden="true"
        style={{
          border: "2px solid var(--blue)",
          borderRadius: "50%",
          height: 7,
          width: 7,
        }}
      />
      {label}
    </Box>
  </Box>
);

const LineGraph = ({ chart, title, height, lineName = "Total" }) => {
  return (
    <ChartFrame height={height || "300px"} title={title}>
      <Box h="100%" display="flex" flexDirection="column">
        <Box flex="1" minH={0}>
          <ResponsiveContainer>
            <LineChart
              data={chart}
              margin={{
                top: 0,
                right: 10,
                left: -10,
                bottom: 10,
              }}
              isAnimationActive={false}
            >
              <CartesianGrid stroke="#EBEBEB" vertical={false} />
              <XAxis
                dataKey="date"
                name="Day"
                axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }}
              />
              <YAxis axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }} />

              <Tooltip />
              <Line
                type="monotone"
                strokeWidth={3}
                dataKey="rate"
                name={lineName}
                stroke={"var(--blue)"}
                dot={{ fill: "var(--blue)", r: 2 }}
                activeDot={{ r: 4 }}
                animationDuration={0}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
        <CenteredLegend label={lineName} />
      </Box>
    </ChartFrame>
  );
};

export default LineGraph;
